// Newsletter issue order, newest first. Links retain their original language.
export const newsletters = [
  ["07/2026", "9304162/0/6232924714"],
  ["05/2026", "9103797/0/1b460f18dc"],
  ["03/2026", "9021868/0/71f59e0107"],
  ["02/2026", "8954971/0/b32d924898"],
  ["01/2026", "8916895/0/c36bef656d"],
].map(([issue, mailing]) => {
  const link = `https://t2736c191.emailsys1a.net/mailing/204/${mailing}/index.html`;
  return {
    id: `newsletter-${mailing.split("/")[0]}`,
    fields: {
      Titel_DE: `Newsletter ${issue}`,
      Title_EN: `Newsletter ${issue}`,
      Datum: issue,
      Link_DE: link,
      Link_EN: link,
      Published: true,
    },
  };
});

export function mergeNewsletters(archive, lang) {
  const linkField = lang === "de" ? "Link_DE" : "Link_EN";
  const seen = new Set(newsletters.map((news) => news.fields[linkField]));
  return [...newsletters, ...archive.filter((news) => {
    const link = news.fields[linkField];
    if (seen.has(link)) return false;
    seen.add(link);
    return true;
  })];
}
